import { Card, CardContent, Switch } from '@material-ui/core';

import { StructuredMetadataTable } from '@backstage/core-components';
import _ from 'lodash';

interface ZpaDialogProps {
  cardClass: string;
  cardContentClass: string;
  zpaEnabled: boolean | undefined;
  updateZpaEnabled: any;
}

export const ZpaEditDialog = ({
  cardClass,
  cardContentClass,
  zpaEnabled,
  updateZpaEnabled,
}: ZpaDialogProps) => {
  const contents = (
    <Card className={cardClass}>
      <CardContent className={cardContentClass}>
        <StructuredMetadataTable
          metadata={{
            'ZPA Enabled': (
              <>
                <Switch
                  id="zpa-enabled"
                  name="zpa-enabled"
                  checked={zpaEnabled}
                  onChange={updateZpaEnabled}
                />
              </>
            ),
          }}
        />
      </CardContent>
    </Card>
  );

  return contents;
};
